import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, TableCell, TableRow } from '@mui/material';
import { HTMLAttributes } from 'react';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { useTranslation } from 'react-i18next';
import { showLabel } from '@/utils/helper';
import { OnoffType } from '@/api/enum/common.enum';
import { PUBLISHED_LISTB } from '@/common/constants/common';
import PublishedChip from '@/common/components/PublishedChip';

type Props = {
	item: any;
} & HTMLAttributes<HTMLDivElement>;

const SortableArticlesItem = ({ item }: Props) => {
	const { t } = useTranslation();
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({
		id: item.id,
	});

	const styles = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? '0.4' : '1',
		backgroundColor: isDragging ? '#F5F5F5' : '',
	};

	return (
		<>
			<TableRow ref={setNodeRef} style={styles}>
				<TableCell component='th' scope='row'>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<DehazeIcon cursor={'pointer'} {...listeners} {...attributes} />
						{`${item.boxTypeName || '-'}`}
					</Box>
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.titleZh || '-'}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{
						<PublishedChip
							published={item?.published}
							publishList={PUBLISHED_LISTB}
						/>
					}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${
						!item.publishedEndAt
							? '-'
							: dayjs(item.publishedEndAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
			</TableRow>
		</>
	);
};

export default SortableArticlesItem;
